import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { withApollo } from 'react-apollo';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import {
  FormField,
  ErrorAlert,
} from '@iris-platform/iris-react-ui';
import { TeamContext } from '../TeamProvider';
import { UPSERT_APPLICATION } from '../ApplicationsTable/queries';

const DialogTitle = withStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: '20px',
    backgroundColor: '#169CEE',
    color: '#fff',
    textAlign: 'center',
    fontSize: '30px',
    margin: 0,
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: '#fff',
  },
  dilogTitle: {
    color: '#fff',
  },
}))((props) => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography classes={{ title: classes.dilogTitle }} variant="title">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing.unit * 2,
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: '20px',
  },
}))(MuiDialogActions);


const styles = theme => ({
  btnWrappr: {
    margin: '20px 10px 0 10px',
    padding: '10px',
    borderTop: '1px solid #ccc',
  },
  cancelBtn: {
    color: '#fff',
    backgroundColor: '#d9534f',
    borderColor: '#d43f3a',
    position: 'absolute',
    left: '10px',
  },
  dilogContent: {
    padding: '20px',
    minWidth: '600px',
  },
});

const initialState = {
  childAppName: '',
  applicationErrorMessage: '',
};

class ApplicationCreate extends React.Component {
  state = initialState

  componentWillReceiveProps() {
    this.setState(initialState);
  }


  onchildAppNameChange(e) {
    this.setState({ [e.target.name]: e.target.value }, () => {
      this.isValid();
    });
  }

  submitForm = async (e) => {
    e.preventDefault();
    const { childAppName } = this.state;
    const { client, onSave } = this.props;
    const { domain, applicationName } = this.props.application;
    const currentTeam = TeamContext.getSelectedTeamId();
    try {
      const { data: { application } } = await client.mutate({
        mutation: UPSERT_APPLICATION,
        variables: {
          application: {
            appType: 'child',
            childAppName,
            domain,
            applicationName,
          },
          currentTeam,
        },
      });
      onSave(application);
    } catch (error) {
      this.setState({
        applicationErrorMessage: `Could not confirm childApp of ${childAppName}. Please use caution when saving`,
      });
    }
  }

  isValid() {
    const { childAppName, currentTeam } = this.state;
    let applicationErrorMessage = '';

    if (childAppName === '') {
      applicationErrorMessage = 'Please provide application name';
    }
    if (childAppName.length > 100) {
      applicationErrorMessage = 'Application name must not be longer than 100 characters';
    }
    if (!childAppName.match(/^[-.a-z0-9]*$/)) {
      applicationErrorMessage = 'Application name must not contain spaces or special characters';
    }

    this.setState({ applicationErrorMessage });
    return applicationErrorMessage === '';
  }

  renderErrors() {
    const { applicationErrorMessage } = this.state;
    return (
      applicationErrorMessage
        ? <ErrorAlert key={`error-${Math.random()}`} message={applicationErrorMessage} /> : null
    );
  }

  render() {
    const { childAppName } = this.state;
    const { classes, open, handleClose } = this.props;
    return (
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        className={classes.dilogRoot}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          New Application
        </DialogTitle>
        <DialogContent className={classes.dilogContent}>
          <form
            onSubmit={e => this.submitForm(e)}
          >
            {this.renderErrors()}
            <FormField
              label="Application Name"
              name="childAppName"
              placeholder="enter application name"
              value={childAppName}
              onChange={(e) => { this.onchildAppNameChange(e); }}
            />
          </form>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={handleClose}
            className={classes.cancelBtn}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={this.submitForm}
          >
            Create
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const ApplicationCreateDialogue = withStyles(styles)(ApplicationCreate);

export default withApollo(ApplicationCreateDialogue);
